/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";

const IDLE_TIME = 30 * 60 * 1000; // 30 minutes

export default function useIdleLogout() {
  const timerRef = useRef(null);

  const clearSession = () => {
    sessionStorage.clear();
    window.location.replace("/login");
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      clearSession();
    }, IDLE_TIME);
  };

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart"
    ];

    // Start timer initially
    resetTimer();

    // Reset timer on any user activity
    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, []);
}
